var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeposit = function SvgDeposit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 26.6666H16C11.5817 26.6666 8 30.2483 8 34.6666V50.6666C8 55.0849 11.5817 58.6666 16 58.6666H48C52.4183 58.6666 56 55.0849 56 50.6666V34.6666C56 30.2483 52.4183 26.6666 48 26.6666Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32V26.6667C56 22.2484 52.4184 18.6667 48 18.6667H46.6667M8 32V26.6667C8 22.2484 11.5817 18.6667 16 18.6667H18.6667M39.2445 25.5002L42.1309 19.2636C43.4248 16.468 42.088 13.1607 39.2149 12.0493L32.4821 9.44495C29.9213 8.45437 27.0267 9.57002 25.7932 12.0231L18.3967 26.732M42.6667 44C42.6667 41.791 44.4576 40 46.6667 40H56V48H46.6667C44.4576 48 42.6667 46.2091 42.6667 44Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDeposit;